import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Ignore errors from other wallet extensions (TronLink, etc.)
window.addEventListener('error', (event) => {
  if (event.message?.includes('tronlink') || 
      event.message?.includes('TronLink') ||
      event.filename?.includes('chrome-extension')) {
    event.preventDefault();
    console.warn('Ignored external extension error:', event.message);
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('tronlink') ||
      event.reason?.message?.includes('TronLink')) {
    event.preventDefault();
    console.warn('Ignored external extension rejection:', event.reason?.message);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
